import React from 'react'
import PropTypes from 'prop-types'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'
import { CATEGORY_THEMES } from 'LiveBoard/config/constants'
import Category from '../Category'
import map from 'lodash/map'
import get from 'lodash/get'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES, TAB_INDEX_INDICATIONS } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

class ParentCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false, isHover: false, parentPosition: 0 }
  }

  componentDidMount() {
    this.props.provideContainer(this.container)
    this.props.provideOutsideClickHandler(this.autoClose)
  }

  componentWillUnmount() {
    this.props.provideContainer(null)
    this.props.provideOutsideClickHandler(null)
  }

  handleSelect = (categoryId) => {
    this.props.onSelect(categoryId)
    this.autoClose()
  }

  onMouseEnter = (event) => {
    event.stopPropagation()
    this.setState({ isHover: true })
  }

  onMouseLeave = (event) => {
    event.stopPropagation()
    this.setState({ isHover: false })
  }

  autoClose = () => {
    this.props.autoClose && this.setState({ isOpen: false })
  }

  renderSubcategories = () => {
    const {
      category, subCategories, selectedCategoryId,
      subCategoryCSS, board, categoryTheme
    } = this.props

    const style = CATEGORY_THEMES.tab === this.props.categoryTheme ?  {left: this.state.parentPosition + 29} : {}
    return (
      <nav>
        <ul style={style} className={this.state.isOpen ? 'show': 'hide'}>
          {
            map(category.subcategories_ids, (id) => {
              const subcategory = subCategories[id]

              return (
                <li key={subcategory.id}
                >
                  <Category
                    board={board}
                    category={subcategory}
                    selectedCategoryId={selectedCategoryId}
                    onSelect={this.handleSelect}
                    categoryCSS={subCategoryCSS}
                    tabIndex={TAB_INDEX_INDICATIONS.skip}
                    categoryTheme={categoryTheme}
                  />
                </li>
              )
            })
          }
        </ul>
      </nav>
    )
  }

  isChildSelected = () => {
    const { subCategories, selectedCategoryId } = this.props
    return !!subCategories[selectedCategoryId]
  }

  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen, parentPosition: (this.container.getBoundingClientRect().left - this.container.parentElement.getBoundingClientRect().left)})
  }

  render() {
    const { categoryCSS, category, categoryTheme } = this.props
    const { isOpen } = this.state
    const isSelected = this.isChildSelected()
    const openClass = isOpen ? 'open' : ''
    const selectedCategoryCSS = get(categoryCSS, 'selected' ,{})
    const hoveredCategoryCSS =  get(categoryCSS, 'hover' ,{})
    const defaultCategoryCSS =  get(categoryCSS, 'default' ,{})
    const accessibilityClass = categoryTheme === 'classic' ? ACCESSIBILITY_CLASSES.main : ACCESSIBILITY_CLASSES.withOffset
    const categoryStyle = isSelected ? selectedCategoryCSS : this.state.isHover ? hoveredCategoryCSS : defaultCategoryCSS
    return (
      <div
        className={`parent-category ${accessibilityClass}`}
        onClick={this.handleClick}
        onKeyDown={triggerClickOnEnter}
        ref={ref => this.container = ref}
        role="button"
        tabIndex={TAB_INDEXES.ParentCategory} >
        <div
          className={`category ${openClass} ${isSelected ? 'active' : ''}`}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          style={categoryStyle.tab}
          >
          {category.name}
          <span className={`icon-full-arrow-up-centered ${isOpen ? 'collapse' : ''}`} />
        </div>
        {this.renderSubcategories()}
      </div>
    )
  }
}

ParentCategory.propTypes = {
  board: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
  subCategories: PropTypes.object.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onSelect: PropTypes.func.isRequired,
  categoryTheme: PropTypes.string,
  categoryCSS: PropTypes.object,
  subCategoryCSS: PropTypes.object,
  autoClose: PropTypes.bool.isRequired,
  provideContainer: PropTypes.func,
  provideOutsideClickHandler: PropTypes.func
}

export default withOutsideClickHandler(ParentCategory)
